<!-- Main view when user is logged in -->
<template>
  <v-app>
    <ClothesRentaNavBar />

    <v-main class="ma-4">
      <router-view name="clothestorental"></router-view>
    </v-main>
    <ClothesRentalFooter />
  </v-app>
</template>
<script>
import ClothesRentaNavBar from '@/components/clothestorental/main/ClothesRentalNavBar';
import ClothesRentalFooter from '@/components/clothestorental/main/ClothesRentalFooter';

export default {
  data() {
    return {
      username: '',
    };
  },
  components: {
    ClothesRentaNavBar,
    ClothesRentalFooter,
  },
  async created() {
    // if (!this.$store.getters.isLoggedIn) {
    //  this.$router.push('/login');
    // }
    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>
